const isPrintModeEnabled = () => {
    if (typeof window == 'undefined') {
        return false
    }

    const items = document.querySelectorAll('.noPrint')

    if (!items.length) {
        return false
    }

    return window.getComputedStyle(items[0]).display == 'none'
}

export default {
    isPrintModeEnabled
}
